import { defineStore } from 'pinia'
import * as vue3Snackbar from 'vue3-snackbar'

export interface SnackbarProps {
  message: LangString
  actionText?: LangString
  duration?: number
  type?: 'warning' | 'success' | 'error' | 'info'
  action?: () => void
}

export const useSnackbarStore = defineStore(
  'snackbar',
  () => {
    const _useSnackbar = vue3Snackbar.useSnackbar()
    const { ls } = useI18n()

    const addMessage = (message: SnackbarProps) => {
      _useSnackbar.add({
        type: message.type,
        title: ls(message.message),
        duration: message.duration || 5000,
        text: ls(message.actionText),
        action: message.action,
      })
    }

    const clearAllMessage = () => {
      _useSnackbar.clear()
    }

    return {
      addMessage,
      clearAllMessage
    }
  },
  { persist: false },
)
